module.exports = __webpack_public_path__ + "static/media/werewolf-host.51c01007.gif";